export default {
    overlays: {
        title: 'Overlays',
        removeOverlay: 'Remove overlay',
        overlayOpacity: 'Overlay opacity',
        golden: 'Golden',
        lightLeak: 'Light leak',
        vintage: 'Vintage',
        mosaic: 'Mosaic',
        rain: 'Rain',
        paper: 'Paper',
        bokeh: 'Bokeh',
        stars: 'Stars',
        wood: 'Wood',
        chop: 'Chop',
        metal: 'Metal',
        painting: 'Painting',
        grain: 'Grain',
        wall: 'Wall',
    },
};
